var _path, _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgRequestedTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 190,
    viewBox: "0 0 191 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109 114H130C147.5 114 154.5 107 154.5 89.5V68.5C154.5 51 147.5 44 130 44H109C91.5 44 84.5 51 84.5 68.5V89.5C84.5 107 91.5 114 109 114Z",
    fill: "url(#paint0_linear_7442_24966)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7442_24966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 130H106C123.5 130 130.5 123 130.5 105.5V84.5C130.5 67 123.5 60 106 60H85C67.5 60 60.5 67 60.5 84.5V105.5C60.5 123 67.5 130 85 130Z",
    fill: "url(#paint1_linear_7442_24966)",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_7442_24966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5 130H106.5C124 130 131 123 131 105.5V84.5C131 67 124 60 106.5 60H85.5C68 60 61 67 61 84.5V105.5C61 123 68 130 85.5 130Z",
    fill: "url(#paint2_linear_7442_24966)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5 130H106.5C124 130 131 123 131 105.5V84.5C131 67 124 60 106.5 60H85.5C68 60 61 67 61 84.5V105.5C61 123 68 130 85.5 130Z",
    stroke: "url(#paint3_linear_7442_24966)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_7442_24966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.6901 79.9999C89.1439 79.9988 87.9783 79.998 86.9163 80.3643C85.9821 80.6866 85.1313 81.2124 84.4253 81.9039C83.6227 82.6899 83.1021 83.7328 82.4116 85.1162C81.5642 86.811 80.1925 89.5597 79.2714 91.4059C78.9531 92.0438 78.794 92.3627 78.8325 92.6223C78.8661 92.8489 78.9916 93.0517 79.1794 93.183C79.3944 93.3333 79.7512 93.3333 80.4649 93.3333H85.8031C87.5764 93.3333 89.1975 94.3352 89.9906 95.9213C90.219 96.3781 90.6859 96.6666 91.1966 96.6666H100.803C101.314 96.6666 101.781 96.3781 102.009 95.9213C102.802 94.3352 104.423 93.3333 106.197 93.3333H111.535C112.249 93.3333 112.605 93.3333 112.82 93.183C113.008 93.0517 113.134 92.8489 113.167 92.6223C113.206 92.3627 113.047 92.0438 112.728 91.4059C111.807 89.5597 110.436 86.8111 109.588 85.1163C108.898 83.7329 108.377 82.6899 107.575 81.9039C106.869 81.2124 106.018 80.6866 105.084 80.3643C104.022 79.998 102.856 79.9988 101.31 79.9999H90.6901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.333 99.3327C114.333 98.3997 114.333 97.9333 114.152 97.5767C113.992 97.2632 113.737 97.0081 113.423 96.8483C113.067 96.6666 112.6 96.6666 111.667 96.6666H106.197C105.686 96.6666 105.219 96.9552 104.991 97.412C104.198 98.9981 102.576 100 100.803 100H91.1966C89.4233 100 87.8022 98.9981 87.0092 97.412C86.7808 96.9552 86.3139 96.6666 85.8031 96.6666H80.3325C79.3995 96.6666 78.9329 96.6666 78.5764 96.8483C78.2628 97.0081 78.0078 97.2632 77.848 97.5767C77.6664 97.9333 77.6664 98.3997 77.6665 99.3326C77.6665 99.6891 77.6666 100.046 77.6666 100.402C77.6665 101.744 77.6665 102.851 77.7402 103.753C77.8168 104.69 77.981 105.551 78.3932 106.36C79.0324 107.614 80.0522 108.634 81.3066 109.273C82.1155 109.686 82.9767 109.85 83.9135 109.926C84.8155 110 85.9228 110 87.2644 110H104.735C106.077 110 107.184 110 108.086 109.926C109.023 109.85 109.884 109.686 110.693 109.273C111.948 108.634 112.967 107.614 113.607 106.36C114.019 105.551 114.183 104.69 114.26 103.753C114.333 102.851 114.333 101.744 114.333 100.402C114.333 100.046 114.333 99.6892 114.333 99.3327Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7442_24966",
    x: 0.5,
    y: 0,
    width: 190,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_7442_24966"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_7442_24966",
    x: 44.25,
    y: 43.25,
    width: 103.5,
    height: 103.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7442_24966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_7442_24966",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_7442_24966",
    x: 77.6665,
    y: 79.9998,
    width: 36.667,
    height: 32.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7442_24966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7442_24966",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7442_24966",
    x1: 84.5,
    y1: 63,
    x2: 154.5,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7442_24966",
    x1: 60.5,
    y1: 74,
    x2: 122.5,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7442_24966",
    x1: 61,
    y1: 74,
    x2: 122,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7442_24966",
    x1: 124,
    y1: 66,
    x2: 67,
    y2: 124.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0285714,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRequestedTask);
export default __webpack_public_path__ + "static/media/ImgRequestedTask.a66c6899a7a99a29010331906fa68dbc.svg";
export { ForwardRef as ReactComponent };